// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  align-items: center !important;
}

ion-list {
  padding-bottom: 0px;
}

.popover-reconfirmation-title {
  padding: unset;
}

@media screen and (max-width: 420px) {
  .list-md-lines-none .item {
    max-height: 40px;
  }
}

.reconfirm-radio {
  margin-right: 5px;
}

.radio-label {
  display: flex;
  align-items: center;
}

.radio-label ion-label {
  margin-left: 10px;
}

.pep-radio-div {
  display: flex;
  flex-direction: row;
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/popover-reconfirmation/popover-reconfirmation.component.scss"],"names":[],"mappings":"AAAA;EACI,8BAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AACA;EACI,cAAA;AAEJ;;AACI;EADJ;IAEI,gBAAA;EAGF;AACF;;AADA;EACI,iBAAA;AAIJ;;AADA;EACI,aAAA;EACA,mBAAA;AAIJ;;AAFE;EACE,iBAAA;AAKJ;;AAHE;EACE,aAAA;EACA,mBAAA;AAMJ","sourcesContent":["ion-item{\r\n    align-items: center!important;\r\n}\r\n\r\nion-list{\r\n    padding-bottom: 0px;\r\n}\r\n.popover-reconfirmation-title{\r\n    padding: unset;\r\n}\r\n.list-md-lines-none .item {\r\n    @media screen and (max-width:420px){\r\n    max-height: 40px;\r\n    }\r\n}\r\n.reconfirm-radio {\r\n    margin-right: 5px;\r\n}\r\n\r\n.radio-label {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  .radio-label ion-label {\r\n    margin-left: 10px; \r\n  }\r\n  .pep-radio-div {\r\n    display: flex;\r\n    flex-direction: row;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
